import { EWebNotificationType, EWebNotificationCategory } from '@/enum';

export const CATEGORY_TAG_STYLES: Record<number, string> = {
  [EWebNotificationCategory.SYSTEM]: 'bg-error-light-50 text-error-secondary',
  [EWebNotificationCategory.LICENSE]:
    'bg-indigo-light-50 text-indigo-secondary',
  [EWebNotificationCategory.CHILD]: 'bg-purple-light-50 text-purple-secondary',
  [EWebNotificationCategory.LESSON]: 'bg-orange-light-50 text-orange-secondary',
  [EWebNotificationCategory.REPORT]:
    'bg-success-light-50 text-success-secondary',
  [EWebNotificationCategory.GENERAL]:
    'bg-neutral-light-100 text-neutral-primary',
  [EWebNotificationCategory.FAQ]: 'bg-warning-light-50 text-warning-secondary',
  [EWebNotificationCategory.POLICY]: 'bg-pink-light-50 text-pink-secondary',
  [EWebNotificationCategory.NOTIFICATION]:
    'bg-brand-light-50 text-brand-default',
  [EWebNotificationCategory.GAME]: 'bg-orange-light-50 text-orange-secondary',
  [EWebNotificationCategory.CLASS]:
    'bg-success-light-50 text-success-secondary',
  [EWebNotificationCategory.STUDENT]:
    'bg-indigo-light-50 text-indigo-secondary',
  [EWebNotificationCategory.TEACHER]:
    'bg-warning-light-50 text-warning-secondary',
  [EWebNotificationCategory.SCHOOL]: 'bg-pink-light-50 text-pink-secondary',
  [EWebNotificationCategory.PARENT]: 'bg-purple-light-50 text-purple-secondary',
};

export const CATEGORY_LOCALES: Record<number, string> = {
  [EWebNotificationCategory.SYSTEM]: 'system',
  [EWebNotificationCategory.LICENSE]: 'license',
  [EWebNotificationCategory.CHILD]: 'child',
  [EWebNotificationCategory.LESSON]: 'lesson',
  [EWebNotificationCategory.REPORT]: 'report',
  [EWebNotificationCategory.GENERAL]: 'general',
  [EWebNotificationCategory.FAQ]: 'faq',
  [EWebNotificationCategory.POLICY]: 'policy',
  [EWebNotificationCategory.NOTIFICATION]: 'notification',
  [EWebNotificationCategory.GAME]: 'game',
  [EWebNotificationCategory.CLASS]: 'class',
  [EWebNotificationCategory.STUDENT]: 'student',
  [EWebNotificationCategory.TEACHER]: 'teacher',
  [EWebNotificationCategory.SCHOOL]: 'school',
  [EWebNotificationCategory.PARENT]: 'parent',
};

export const NOTIFICATION_TYPE_LOCALES: Record<EWebNotificationType, string> = {
  [EWebNotificationType.LESSON_CREATED]: 'lesson-created',
  [EWebNotificationType.LESSON_DELETED]: 'lesson-deleted',
  [EWebNotificationType.LESSON_BLOCKED]: 'lesson-blocked',
  [EWebNotificationType.LESSON_UNBLOCKED]: 'lesson-unblocked',
  [EWebNotificationType.CLASS_CREATED]: 'class-created',
  [EWebNotificationType.CLASS_DELETED]: 'class-deleted',
  [EWebNotificationType.CLASS_BLOCKED]: 'class-blocked',
  [EWebNotificationType.CLASS_UNBLOCKED]: 'class-unblocked',
  [EWebNotificationType.LESSON_ASSIGNED]: 'lesson-assigned',
  [EWebNotificationType.CLASS_ASSIGNED]: 'class-assigned',
  [EWebNotificationType.TEACHER_CREATED]: 'teacher-created',
  [EWebNotificationType.TEACHER_UPDATED]: 'teacher-updated',
  [EWebNotificationType.TEACHER_DELETED]: 'teacher-deleted',
  [EWebNotificationType.STUDENT_CREATED]: 'student-created',
  [EWebNotificationType.STUDENT_UPDATED]: 'student-updated',
  [EWebNotificationType.STUDENT_DELETED]: 'student-deleted',
  [EWebNotificationType.TEACHER_BLOCKED]: 'teacher-blocked',
  [EWebNotificationType.TEACHER_UNBLOCKED]: 'teacher-unblocked',
  [EWebNotificationType.STUDENT_BLOCKED]: 'student-blocked',
  [EWebNotificationType.STUDENT_UNBLOCKED]: 'student-unblocked',
  [EWebNotificationType.SCHOOL_BLOCKED]: 'school-blocked',
  [EWebNotificationType.SCHOOL_UNBLOCKED]: 'school-unblocked',
  [EWebNotificationType.ADMIN_BLOCKED]: 'admin-blocked',
  [EWebNotificationType.ADMIN_UNBLOCKED]: 'admin-unblocked',
  [EWebNotificationType.PARENT_DELETED]: 'parent-deleted',
  [EWebNotificationType.GAME_STATUS_UPDATED]: 'game-status-updated',
  [EWebNotificationType.CHILD_COMPLETED_GAME]: 'child-completed-game',
  [EWebNotificationType.REPORT_CREATED]: 'report-created',
  [EWebNotificationType.REPORT_STATUS_UPDATED]: 'report-status-updated',
  [EWebNotificationType.NEW_DEVICE_LOGIN]: 'new-device-login',
  [EWebNotificationType.FAQ_CREATED]: 'faq-created',
  [EWebNotificationType.FAQ_UPDATED]: 'faq-updated',
  [EWebNotificationType.FAQ_DELETED]: 'faq-deleted',
  [EWebNotificationType.POLICY_CREATED]: 'policy-created',
  [EWebNotificationType.POLICY_UPDATED]: 'policy-updated',
  [EWebNotificationType.POLICY_DELETED]: 'policy-deleted',
  [EWebNotificationType.DATA_RESTORED]: 'data-restored',
  [EWebNotificationType.SCHOOL_CREATED]: 'school-created',
  [EWebNotificationType.SCHOOL_UPDATED]: 'school-updated',
  [EWebNotificationType.SCHOOL_DELETED]: 'school-deleted',
  [EWebNotificationType.PARENT_REGISTERED]: 'parent-registered',
  [EWebNotificationType.PARENT_BLOCKED]: 'parent-blocked',
  [EWebNotificationType.PARENT_UNBLOCKED]: 'parent-unblocked',
  [EWebNotificationType.ADMIN_DELETED]: 'admin-deleted',
};

export const NOTIFICATION_TYPE_TO_CATEGORY: Record<
  EWebNotificationType,
  EWebNotificationCategory
> = {
  [EWebNotificationType.LESSON_CREATED]: EWebNotificationCategory.LESSON,
  [EWebNotificationType.LESSON_DELETED]: EWebNotificationCategory.LESSON,
  [EWebNotificationType.LESSON_BLOCKED]: EWebNotificationCategory.LESSON,
  [EWebNotificationType.LESSON_UNBLOCKED]: EWebNotificationCategory.LESSON,
  [EWebNotificationType.CLASS_CREATED]: EWebNotificationCategory.CLASS,
  [EWebNotificationType.CLASS_DELETED]: EWebNotificationCategory.CLASS,
  [EWebNotificationType.CLASS_BLOCKED]: EWebNotificationCategory.CLASS,
  [EWebNotificationType.CLASS_UNBLOCKED]: EWebNotificationCategory.CLASS,
  [EWebNotificationType.LESSON_ASSIGNED]: EWebNotificationCategory.LESSON,
  [EWebNotificationType.CLASS_ASSIGNED]: EWebNotificationCategory.CLASS,
  [EWebNotificationType.TEACHER_CREATED]: EWebNotificationCategory.TEACHER,
  [EWebNotificationType.TEACHER_UPDATED]: EWebNotificationCategory.TEACHER,
  [EWebNotificationType.TEACHER_DELETED]: EWebNotificationCategory.TEACHER,
  [EWebNotificationType.STUDENT_CREATED]: EWebNotificationCategory.STUDENT,
  [EWebNotificationType.STUDENT_UPDATED]: EWebNotificationCategory.STUDENT,
  [EWebNotificationType.STUDENT_DELETED]: EWebNotificationCategory.STUDENT,
  [EWebNotificationType.TEACHER_BLOCKED]: EWebNotificationCategory.TEACHER,
  [EWebNotificationType.TEACHER_UNBLOCKED]: EWebNotificationCategory.TEACHER,
  [EWebNotificationType.STUDENT_BLOCKED]: EWebNotificationCategory.STUDENT,
  [EWebNotificationType.STUDENT_UNBLOCKED]: EWebNotificationCategory.STUDENT,
  [EWebNotificationType.SCHOOL_BLOCKED]: EWebNotificationCategory.SCHOOL,
  [EWebNotificationType.SCHOOL_UNBLOCKED]: EWebNotificationCategory.SCHOOL,
  [EWebNotificationType.ADMIN_BLOCKED]: EWebNotificationCategory.SYSTEM,
  [EWebNotificationType.ADMIN_UNBLOCKED]: EWebNotificationCategory.SYSTEM,
  [EWebNotificationType.PARENT_DELETED]: EWebNotificationCategory.PARENT,
  [EWebNotificationType.GAME_STATUS_UPDATED]: EWebNotificationCategory.GAME,
  [EWebNotificationType.CHILD_COMPLETED_GAME]: EWebNotificationCategory.GAME,
  [EWebNotificationType.REPORT_CREATED]: EWebNotificationCategory.REPORT,
  [EWebNotificationType.REPORT_STATUS_UPDATED]: EWebNotificationCategory.REPORT,
  [EWebNotificationType.NEW_DEVICE_LOGIN]: EWebNotificationCategory.SYSTEM,
  [EWebNotificationType.FAQ_CREATED]: EWebNotificationCategory.FAQ,
  [EWebNotificationType.FAQ_UPDATED]: EWebNotificationCategory.FAQ,
  [EWebNotificationType.FAQ_DELETED]: EWebNotificationCategory.FAQ,
  [EWebNotificationType.POLICY_CREATED]: EWebNotificationCategory.POLICY,
  [EWebNotificationType.POLICY_UPDATED]: EWebNotificationCategory.POLICY,
  [EWebNotificationType.POLICY_DELETED]: EWebNotificationCategory.POLICY,
  [EWebNotificationType.DATA_RESTORED]: EWebNotificationCategory.GENERAL,
  [EWebNotificationType.SCHOOL_CREATED]: EWebNotificationCategory.SCHOOL,
  [EWebNotificationType.SCHOOL_UPDATED]: EWebNotificationCategory.SCHOOL,
  [EWebNotificationType.SCHOOL_DELETED]: EWebNotificationCategory.SCHOOL,
  [EWebNotificationType.PARENT_REGISTERED]: EWebNotificationCategory.PARENT,
  [EWebNotificationType.PARENT_BLOCKED]: EWebNotificationCategory.PARENT,
  [EWebNotificationType.PARENT_UNBLOCKED]: EWebNotificationCategory.PARENT,
  [EWebNotificationType.ADMIN_DELETED]: EWebNotificationCategory.SYSTEM,
};
